import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import SignIn from './components/SignIn';
import Progress from './components/Progress';
import Proofread from './components/Proofread';
import Utils from './lib/Utils';

import Auth from './lib/Auth';

class App extends React.Component {
  componentDidMount = () => {
    if (this.countdownElm) {
      this.doCountdown();
    }
  }
  doCountdown = () => {
    setTimeout(() => {
      let n = parseInt(this.countdownElm.innerText, 10) - 1;
      if (n <= 0) {
        window.location.href = "https://portal.appx.co.jp";
      }
      else {
        this.countdownElm.innerText = n;
        this.doCountdown();
      }
    }, 1000);
  }

  render () {
    let searches = Utils.getUrlVars();

    if (((new Date()).toLocaleDateString('sv-SE') >= '2026-11-01') && window.location.host === 'as.adachi-printing.co.jp') {
      return (<div style={{margin: '10%', textAlign:'center'}}>
        <h2>アルバムサポートはURLが変更されました。</h2>
        <p><span ref={ref=>{this.countdownElm = ref;}} style={{color:'crimson', marginRight:'0.3em', fontSize:'1.2em'}}>10</span>秒後に新しいURLへ移動します。自動で切り替わらない場合は<a href="https://portal.appx.co.jp" style={{color:'crimson', fontSize:'1.2em'}}>こちら</a>をクリックしてください。</p>
      </div>)
    }

    return (
      <Router>
        <Switch>
          <Route exact path="/signin" component={SignIn}/>
          <Route path="/proofread" 
            render={(props)=><Proofread searches={searches} {...props}/>} />
          <Auth>
            <Switch>_
              <Route exact path="/" 
                render={(props)=><Progress searches={searches} {...props}/>} />
              <Redirect exact from="/" to="/signin"/>
              <Redirect exact path="/progress" to="/"/>
              <Redirect exact path="/order-confirm" to="/"/>
              <Route render={() => {
                setTimeout(()=>{
                  window.location.href = '/';
                }, 5000);
                return (
                  <div style={{padding:'10px 20px'}}>
                    <h1>Document Not Found.</h1>
                    <p>Redirect to root at after 5 seconds.</p>
                  </div>
                );
              }} />
            </Switch>
          </Auth>
        </Switch>
      </Router>
    );
  }
}

export default App;
